import React, { useState } from 'react';
import { AdminTemplate, AdminPublicTemplate, AdminUserTemplate } from '../../types/types';
import APIService from '../../services/APIService';
import { useAccessToken } from '@features/user';
import UserPicker from './pickers/UserPicker';

interface TemplateToUserModalProps {
  isOpen: boolean;
  onClose: () => void;
  template: AdminTemplate | AdminPublicTemplate | AdminUserTemplate;
  type: string;
}

export const TemplateToUserModal: React.FC<TemplateToUserModalProps> = ({
  isOpen,
  onClose,
  template,
  type,
}) => {
  const { getAccessToken } = useAccessToken();
  const [displayName, setDisplayName] = useState<string>(template.template_name);
  const [selectedUserId, setSelectedUserId] = useState<string>('');

  const handleDisplayNameChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    setDisplayName(event.target.value);
  };

  const handleSubmit = async () => {
    const accessToken = await getAccessToken();

    const response = await APIService.makeAPIPostRequest({
      requestString: '/template/assignTemplateToUser',
      accessToken: accessToken,
      body: {
        target_user_id: selectedUserId,
        template_id: template.template_id,
        display_name: displayName,
        template_type: type,
      },
    });

    if (response.ok) {
      console.log('successfully added');
      onClose();
    }
  };

  const handleOverlayClick = (event: any) => {
    if (event.target === event.currentTarget) {
      onClose();
    }
  };

  if (!isOpen) {
    return null;
  }

  return (
    <div className="fixed z-10 inset-0 overflow-y-auto w-full">
      <div className="flex items-center justify-center min-h-screen" onClick={handleOverlayClick}>
        <div className="bg-white p-4 rounded-lg text-left overflow-hidden shadow-xl w-[80%]">
          <div className="mb-4">
            <label className="block text-sm text-gray-500 mb-2">
              Select a User to assign template to
            </label>
            <UserPicker
              onUserSelect={setSelectedUserId}
              minSearchLength={1}
            />
            {selectedUserId && (
              <div className="mt-2 text-sm text-gray-600">Selected: {selectedUserId}</div>
            )}
          </div>
          <div className="mb-4">
            <label htmlFor="displayName" className="block text-sm font-medium text-gray-700">
              Display Name
            </label>
            <input
              type="text"
              name="displayName"
              id="displayName"
              value={displayName}
              onChange={handleDisplayNameChange}
              placeholder="Enter a custom name for this template"
              className="mt-1 block w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm"
            />
          </div>
          <div className="mt-5 flex gap-2">
            <button
              type="button"
              onClick={handleSubmit}
              className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Submit
            </button>
            <button
              type="button"
              onClick={onClose}
              className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md shadow-sm text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
            >
              Cancel
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TemplateToUserModal;